import AudioRecorder from 'audio-recorder-polyfill/index.js';
import mpegEncoder from 'audio-recorder-polyfill/mpeg-encoder/index.js';
export { WebMediaRecorder };
AudioRecorder.encoder = mpegEncoder;
AudioRecorder.prototype.mimeType = 'audio/mpeg';
window.MediaRecorder = AudioRecorder;
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = WebMediaRecorder;
}
else {
    if (typeof define === 'function' && define.amd) {
        define([], function () {
            return WebMediaRecorder;
        });
    }
    else {
        window.WebMediaRecorder = WebMediaRecorder;
    }
}
var append;
var audio;
var downloadMethod;
var rootPath;
var rootUrl;
var uploadMethod;
var callback_endRecord;
function WebMediaRecorder(config) {
    config = config || {};
    var self = this;
    Init();
    function Init() {
        self.sessionId = config.sessionId;
        self.questionId = config.questionId;
        self.mock = config.mock !== undefined ? config.mock : true;
        self.timeslice = config.timeslice || null;
        rootPath = config.rootPath;
        rootUrl = config.serviceUrl;
        downloadMethod = config.downloadMethod;
        uploadMethod = config.uploadMethod;
        self.isRecording = false;
        self.isPlaying = false;
        append = false;
        audio = null;
    }
    return this;
}
WebMediaRecorder.prototype = {
    startRecording: function (callback) {
        var confirmMessage = "Recording new audio will delete any existing audio for this question.";
        if (localStorage.getItem("userslanguage") == "nl")
            confirmMessage = "Als u nieuwe audio opneemt, wordt alle bestaande audio voor deze vraag verwijderd.";
        if (audio !== null ? !confirm(confirmMessage) : false) {
            return;
        }
        var self = this;
        navigator.mediaDevices.getUserMedia({ audio: true }).then(function (stream) {
            self.recorder = new MediaRecorder(stream, { audioBitsPerSecond: 128000, mimeType: "audio/mpeg" });
            self.recorder.addEventListener('dataavailable', function (e) {
                console.log('dataavailable: ' + e.data.size);
                var worker = new Worker(rootPath + '/WebMediaRecorder.SendData.Worker.js');
                worker.onmessage = function (e) {
                    var successful = e.data['successful'];
                    var errType = e.data['errType'];
                    if (!successful) {
                        console.error("Error while saving audio: " + errType);
                    }
                    if (self.recorder.state == 'inactive') {
                        self.isRecording = false;
                        if (callback_endRecord) {
                            callback_endRecord(successful, errType);
                        }
                    }
                };
                worker.postMessage({
                    sid: self.sessionId,
                    qid: self.questionId,
                    data: e.data,
                    mock: self.mock,
                    url: rootUrl + uploadMethod,
                    append: append
                });
                if (!append) {
                    append = true;
                }
            });
            append = false;
            self.isRecording = true;
            self.recorder.start(self.timeslice);
            if (callback) {
                callback(true, null);
            }
        }).catch(function (err) {
            var message = "Microphone not detected";
            if (err.message.includes("Requested device not found")) {
                if (localStorage.getItem("userslanguage") == "nl")
                    message = "Microfoon niet gedetecteerd";
                callback(false, message);
            }
            else {
                message = "Error recording audio";
                if (localStorage.getItem("userslanguage") == "nl")
                    message = "Fout bij opnemen audio";
                callback(false, message);
                console.error(err);
            }
        });
    },
    stopRecording: function (callback) {
        callback_endRecord = callback;
        this.recorder.stop();
        this.recorder.stream.getTracks().forEach(function (i) { return i.stop(); });
    },
    loadAudio: function (callback) {
        var self = this;
        var worker = new Worker(rootPath + '/WebMediaRecorder.DownloadData.Worker.js');
        worker.onmessage = function (e) {
            var successful = e.data['successful'];
            var errType = e.data['errType'];
            var data = e.data['data'];
            if (successful) {
                if (!audio) {
                    audio = new Audio(data);
                }
                else {
                    audio.src = data;
                }
                audio.onloadedmetadata = callback ?
                    (function (e) {
                        callback(true, null, audio.duration);
                    })
                    : null;
                audio.load();
            }
            else {
                audio = null;
                console.error("Error loading audio: " + errType);
                if (callback) {
                    callback(successful, errType, null);
                }
            }
        };
        worker.postMessage({
            sid: self.sessionId,
            qid: self.questionId,
            mock: self.mock,
            url: rootUrl + downloadMethod
        });
    },
    play: function (callback) {
        if (!audio) {
            return;
        }
        var self = this;
        audio.onended = function (e) {
            self.isPlaying = false;
            if (callback) {
                callback();
            }
        };
        this.isPlaying = true;
        audio.play();
    },
    stop: function (callback) {
        if (!audio) {
            return;
        }
        this.isPlaying = false;
        audio.pause();
        audio.currentTime = 0;
        if (callback) {
            callback();
        }
    }
};
//# sourceMappingURL=WebMediaRecorder.js.map